/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createFractionClass } from '../../factoriesAny.js';
export var FractionDependencies = {
  createFractionClass: createFractionClass
};